import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/integratedMultimediaProject'

export default function IntegratedMultimediaProject() {
  return <ProjectLayout data={data} />
}
